/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Send_BodyInputs */

const en_mcp_cap_send_body = /** @type {(inputs: Mcp_Cap_Send_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasted text, chat attachments, local files and public links, up to 20 MiB each.`)
};

const es_mcp_cap_send_body = /** @type {(inputs: Mcp_Cap_Send_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto pegado, adjuntos del chat, archivos locales y enlaces públicos, hasta 20 MiB cada uno.`)
};

/**
* | output |
* | --- |
* | "Pasted text, chat attachments, local files and public links, up to 20 MiB each." |
*
* @param {Mcp_Cap_Send_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_send_body = /** @type {((inputs?: Mcp_Cap_Send_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Send_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_send_body(inputs)
	return en_mcp_cap_send_body(inputs)
});